import React from 'react';
import queryString from 'query-string';
import { Redirect, type RouteContext } from '@atlassian/react-resource-router';
import {
	ContextualAnalyticsData,
	FireScreenAnalytics,
	SCREEN,
} from '@atlassian/jira-product-analytics-bridge';
import {
	ASSETS_APP_OBJECT_ROUTE_PREFIX,
	ASSETS_APP_ROUTE_PREFIX,
} from '@atlassian/jira-servicedesk-insight-urls/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const getRedirectionUrl = (match: RouteContext['match'], query: RouteContext['query']) => {
	const pattern = /\/jira\/servicedesk\/(assets|insight)/;

	// We are intentionally using a new regex for being extra safe and not to disturb original regex used for majority of the app routes
	const objectPathPattern = /\/jira\/servicedesk\/insight\/assets/;

	let redirectionUrl: string;

	if (match.url.match(objectPathPattern) && fg('assets_object_route_redirection_fix')) {
		redirectionUrl = match.url.replace(objectPathPattern, ASSETS_APP_OBJECT_ROUTE_PREFIX);
	} else {
		redirectionUrl = match.url.replace(pattern, ASSETS_APP_ROUTE_PREFIX);
	}

	if (Object.keys(query).length > 0) {
		redirectionUrl += `?${queryString.stringify(query)}`;
	}

	return redirectionUrl;
};

export const AssetsAppRedirect = ({ match, query }: RouteContext) => {
	const redirectionUrl = getRedirectionUrl(match, query);

	const analyticsAttributes = {
		matchedRoute: match.path,
	};

	return (
		<ContextualAnalyticsData sourceType={SCREEN} sourceName="assetsAppRedirect">
			<Redirect to={redirectionUrl} push={false} />
			<FireScreenAnalytics attributes={analyticsAttributes} />
		</ContextualAnalyticsData>
	);
};
